import { Box, OutlinedInputProps, Skeleton, SkeletonProps, useTheme } from "@mui/material";
import React, { FC, PropsWithChildren } from "react";
import { ConditionalWrapper } from "@sinch/components/ConditionalWrapper/ConditionalWrapper";
import { FormControlWrapper, FormControlWrapperProps } from "@sinch/components";

type InputSkeletonProps = SkeletonProps & {
  active?: boolean;
  size?: OutlinedInputProps["size"];
  formControlProps?: Omit<FormControlWrapperProps, "children">;
};
export const InputSkeleton: FC<InputSkeletonProps> = ({
  children,
  size,
  active = false,
  formControlProps,
  ...props
}) => {
  const { shape } = useTheme();
  if (!active) {
    return children;
  }

  return (
    <ConditionalWrapper
      condition={Boolean(formControlProps)}
      wrapper={(skeleton) => <FormControlWrapper {...formControlProps}>{skeleton}</FormControlWrapper>}
    >
      <>
        <Skeleton
          {...props}
          component={SkeletonPlaceholder}
          height={size === "small" ? shape.inputSmallHeight : shape.inputMediumHeight}
          variant="input"
        />
        <Box
          sx={{
            display: "none",
          }}
        >
          {children}
        </Box>
      </>
    </ConditionalWrapper>
  );
};

const SkeletonPlaceholder: FC<PropsWithChildren> = ({ children: componentChildren, ...componentProps }) => (
  <div {...componentProps}>
    <Box sx={{ visibility: "visible !important", position: "absolute", padding: "0px 16px" }}>Loading...</Box>
    {componentChildren}
  </div>
);
